<template>
  <div class="headdom mr-24">
    <div
      :class="activeItem == menuitem.id ? 'headitem itemactive' : 'headitem'"
    >
      <span>{{ menuitem.name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name:'',
  props: {
    menuitem: {
      type: Object,
      default() {
        return {};
      },
    },
    activeItem: Number,
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {
    let self = this;
  },
  methods: {},
};
</script>

<style lang="scss">
.headdom {
  .headitem {
    padding: 4px 16px;
    font-size: 14px;
    color: #919caf;
    border-radius: 20px;
  }
  .itemactive {
    background: rgba(60, 138, 255, 0.1);
    color: #3c8aff;
  }
}
</style>
